<template lang="pug">
  div
    p.mb-0.w-100.text-primary Datos de Contacto
    hr
    template(v-if="contact.full_name")
      p.mb-0 Nombre Completo
      p.text-secondary.mb-0 {{ contact.full_name }}
      hr
    template(v-if="contact.commercial_name")
      p.mb-0 Nombre comercial
      p.text-secondary.mb-0 {{ contact.commercial_name }}
      hr
    template(v-if="contact.email")
      p.mb-0 Correo electrónico
      p.text-secondary.mb-0 {{ contact.email }}
      hr
    template(v-if="contact.phone")
      p.mb-0 Número de teléfono
      p.text-secondary.mb-0 {{ contact.phone }}
      hr
    template(v-if="contact.cell_phone")
      p.mb-0 Número de celular
      p.text-secondary.mb-0 {{ contact.cell_phone }}
      hr
    template(v-if="contact.rfc")
      p.mb-0 RFC
      p.text-secondary.mb-0 {{ contact.rfc }}
      hr
    template(v-if="contactBirthday")
      p.mb-0 Cumpleaños
      p.text-secondary.mb-0 {{ contactBirthday }}
      hr
    template(v-if="contact.address")
      p.mb-0 Dirección
      p.text-secondary.mb-0 {{ contact.address }}
      hr
    template(v-if="contact.bussines_address")
      p.mb-0 Dirección comercial
      p.text-secondary.mb-0 {{ contact.bussines_address }}
      hr
    template(v-if="contact.title")
      p.mb-0 Título
      p.text-secondary.mb-0 {{ contact.title }}
      hr
    template(v-if="contact.stage")
      p.mb-0 Etapa
      p.text-secondary.mb-0 {{ contact.stage }}
      hr
    template(v-if="contact.main_platform")
      p.mb-0 Plataforma principal
      p.text-secondary.mb-0 {{ contact.main_platform }}
      hr
    template(v-for="data in contact.custom_data")
      p.mb-0 {{ data.name }}
      p.text-secondary.mb-0 {{ data.value }}
      hr
</template>

<script>
export default {
  name: "ContactData",
  props: {
    contact: {
      type: Object,
      required: true
    }
  },
  computed: {
    contactBirthday() {
      if (!this.contact.birthday) {
        return null
      } else {
        if (isNaN(this.contact.birthday)) {
          return this.contact.birthday
        } else {
          const dateAsNumber = parseInt(this.contact.birthday)
          return this.$moment(dateAsNumber).isValid() ? this.$moment(dateAsNumber).format('DD/MM/YYYY') : this.contact.birthday
        }
      }
    }
  }
}
</script>
